<template>
  <header class="header">
    <div class="header__main">
      <a href="#" target="_self" class="navbar-brand font-weight-bold ml-1 text-white">
        <img :src="$props.logo" height="25px;" alt="" class="d-inline-block align-top">
        {{$props.name}}
        <small style="font-size:12px" class="font-weight-light">by <b>Systemico</b>.</small>
      </a>
      <button class="header__menu" @click="showMenu()">
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" class="bi bi-list" viewBox="0 0 16 16">
          <path fill-rule="evenodd" d="M2.5 12a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5zm0-4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5zm0-4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5z"/>
        </svg>
      </button>
      <div class="header__nav">
        <div class="products-link">
          <button class="btn-products" v-on:click="showProducts()">
            {{ language === 'ES' ? 'Más Productos' : (language === 'PT' ? 'Mais Produtos' : (language === 'FR' ? 'Plus de Produits' : 'More Products')) }}
          </button>
        </div>
        <div class="translate">
          <button class="btn-translate" v-on:click="showTranslate()">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-globe mr-1" viewBox="0 0 16 16">
              <path d="M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8zm7.5-6.923c-.67.204-1.335.82-1.887 1.855A7.97 7.97 0 0 0 5.145 4H7.5V1.077zM4.09 4a9.267 9.267 0 0 1 .64-1.539 6.7 6.7 0 0 1 .597-.933A7.025 7.025 0 0 0 2.255 4H4.09zm-.582 3.5c.03-.877.138-1.718.312-2.5H1.674a6.958 6.958 0 0 0-.656 2.5h2.49zM4.847 5a12.5 12.5 0 0 0-.338 2.5H7.5V5H4.847zM8.5 5v2.5h2.99a12.495 12.495 0 0 0-.337-2.5H8.5zM4.51 8.5a12.5 12.5 0 0 0 .337 2.5H7.5V8.5H4.51zm3.99 0V11h2.653c.187-.765.306-1.608.338-2.5H8.5zM5.145 12c.138.853.33 1.603.582 2.145.552 1.035 1.218 1.65 1.887 1.855V12H5.145zm.14 2.461c.142.194.3.372.469.532A7.025 7.025 0 0 1 2.255 12h1.835c.074.28.175.553.3.816.147.311.32.603.515.867l.18.278zM2.851 10a7.024 7.024 0 0 1-.596-.933 9.268 9.268 0 0 1-.64-1.539H1.118a6.957 6.957 0 0 0 .708 2.5H2.85zm1.207 2h1.835c-.173.813-.412 1.448-.654 1.854A9.27 9.27 0 0 1 4.69 12.5a6.726 6.726 0 0 1-.632-.5zm0-9.5c.173-.813.412-1.448.654-1.854A9.27 9.27 0 0 1 5.46 2.5a6.726 6.726 0 0 1 .632.5H4.058zm9.734 1.5a6.959 6.959 0 0 0-.708-2.5H11.29c.173.813.412 1.448.654 1.854.184.31.394.619.63.5H13.792zM11.29 14.077c.67-.204 1.335-.82 1.887-1.855.253-.542.444-1.292.582-2.145H11.29v3.077zm0-10.154H13.79c-.03-.877-.138-1.718-.312-2.5h-2.49c.03.877.138 1.718.312 2.5zM10.855 4H8.5V1.077c.67.204 1.335.82 1.887 1.855.253.542.444 1.292.582 2.145zM15.344 7.5a6.959 6.959 0 0 0-.656-2.5h-2.49c.174.782.282 1.623.312 2.5h2.834zM11.51 12c-.138.853-.33 1.603-.582 2.145-.552 1.035-1.218 1.65-1.887 1.855V12h2.469zm0-2.5a12.495 12.495 0 0 0 .337-2.5H8.5V11h2.99a12.495 12.495 0 0 0 .337-2.5h-.317zm3.372 1.5a6.959 6.959 0 0 0 .708-2.5H12.85c-.03.877-.138 1.718-.312 2.5h2.49zM11.29 14.077h2.502c-.03.877-.138 1.718-.312 2.5h-2.49c.03-.877.138-1.718.312-2.5zM14.653 11a12.495 12.495 0 0 0 .338-2.5H12.5V11h2.153z"/>
            </svg>
            <span v-if="language">{{ language }}</span>
          </button>
        </div>
      </div>
    </div>
    <transition name="slide-fade">
      <div class="header__floating-promo" v-if="showPromo">
        <button class="close-promo" @click="showPromo = false">
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" class="bi bi-x" viewBox="0 0 16 16">
            <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z"/>
          </svg>
        </button>
        <div class="promo-content">
          <div class="promo-header">
            <div class="promo-icon">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <circle cx="12" cy="12" r="10"></circle>
                <line x1="12" y1="16" x2="12" y2="12"></line>
                <line x1="12" y1="8" x2="12.01" y2="8"></line>
              </svg>
            </div>
            <p>{{ language === 'ES' ? 'Simplifica tu negocio con Systemico' : (language === 'PT' ? 'Simplifique o seu negócio com a Systemico' : (language === 'FR' ? 'Simplifiez votre entreprise avec Systemico' : 'Simplify your business with Systemico')) }}</p>
          </div>
          <div class="promo-actions">
            <a href="https://systemico.net/discount" target="_blank" rel="noopener noreferrer" class="promo-button discount">
              {{ language === 'ES' ? 'Quiero un descuento' : (language === 'PT' ? 'Quero um desconto' : (language === 'FR' ? 'Je veux une remise' : 'I want a discount')) }}
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-tag ml-1" viewBox="0 0 16 16">
                <path d="M6 4.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0zm-1 0a.5.5 0 1 0-1 0 .5.5 0 0 0 1 0z"/>
                <path d="M2 1h4.586a1 1 0 0 1 .707.293l7 7a1 1 0 0 1 0 1.414l-4.586 4.586a1 1 0 0 1-1.414 0l-7-7A1 1 0 0 1 1 6.586V2a1 1 0 0 1 1-1zm0 5.586 7 7L13.586 9l-7-7H2v4.586z"/>
              </svg>
            </a>
            <a href="https://systemico.net" target="_blank" rel="noopener noreferrer" class="promo-button">
              {{ language === 'ES' ? 'Saber más' : (language === 'PT' ? 'Saber mais' : (language === 'FR' ? 'Savoir plus' : 'Learn more')) }}
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-info-circle ml-1" viewBox="0 0 16 16">
                <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"/>
                <path d="m8.93 6.588-2.29.287-.082.38.45.083c.294.07.352.176.288.469l-.738 3.468c-.194.897.105 1.319.808 1.319.545 0 1.178-.252 1.465-.598l.088-.416c-.2.176-.492.246-.686.246-.275 0-.375-.193-.304-.533L8.93 6.588zM9 4.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0z"/>
              </svg>
            </a>
            <a href="https://systemico.net/contact" target="_blank" rel="noopener noreferrer" class="promo-button secondary">
              {{ language === 'ES' ? 'Contactar experto' : (language === 'PT' ? 'Contactar especialista' : (language === 'FR' ? 'Contacter un expert' : 'Contact an expert')) }}
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-chat-dots" viewBox="0 0 16 16">
                <path d="M5 8a1 1 0 1 1-2 0 1 1 0 0 1 2 0zm4 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0zm4 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0z"/>
                <path d="m2.165 15.803.02-.004c1.83-.363 2.948-.842 3.468-1.105A9.06 9.06 0 0 0 8 15c4.418 0 8-3.134 8-7s-3.582-7-8-7-8 3.134-8 7c0 1.76.743 3.37 1.97 4.6a10.437 10.437 0 0 1-.824 2.492 1.23 1.23 0 0 0 .196 1.311c.142.175.363.283.587.294a1.24 1.24 0 0 0 .23-.014zM8 2c3.866 0 7 2.686 7 6s-3.134 6-7 6c-.492 0-.972-.043-1.432-.126a.499.499 0 0 0-.414.086c-.463.264-1.294.62-2.138.835.302-.495.556-1.057.709-1.667a.499.499 0 0 0-.21-.498A6.994 6.994 0 0 1 2 8c0-3.314 3.134-6 7-6z"/>
              </svg>
            </a>
          </div>
        </div>
      </div>
    </transition>
    <div class="header__products-dropdown" v-if="products" @mouseleave="products = false">
      <div class="dropdown-header">
        <h3>{{ language === 'ES' ? 'Productos' : (language === 'PT' ? 'Produtos' : (language === 'FR' ? 'Produits' : 'Products')) }}</h3>
        <p>{{ language === 'ES' ? 'Soluciones innovadoras para tu negocio.' : (language === 'PT' ? 'Soluções inovadoras para o seu negócio.' : (language === 'FR' ? 'Des solutions innovantes pour votre entreprise.' : 'Innovative solutions for your business.')) }}</p>
      </div>
      <div class="products-grid">
        <a
          v-for="(item, index) in productsList"
          :key="index"
          :href="item.link"
          target="_blank"
          rel="noopener noreferrer"
          class="product-item"
        >
          <div class="product-icon">
            <img :src="$cdnSystemico + 'icons/products/' + item.icon" :alt="item.name" />
          </div>
          <div class="product-info">
            <span class="product-name">{{ item.name }}</span>
            <span class="product-description">{{ item.description[language] || item.description['EN'] }}</span>
          </div>
        </a>
      </div>
      <div class="dropdown-footer">
        <a href="https://systemico.net/products" target="_blank" rel="noopener noreferrer">
          {{ language === 'ES' ? 'Ver todos los productos' : (language === 'PT' ? 'Ver todos os produtos' : (language === 'FR' ? 'Voir tous les produits' : 'View all products')) }}
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-arrow-right ml-1" viewBox="0 0 16 16">
            <path fill-rule="evenodd" d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8z"/>
          </svg>
        </a>
      </div>
    </div>
    <div class="header__translate-dropdown" v-if="stateTranslate" @mouseleave="stateTranslate = false">
      <div class="dropdown-header">
        <h3>{{ language === 'ES' ? 'Idioma' : (language === 'PT' ? 'Idioma' : (language === 'FR' ? 'Langue' : 'Language')) }}</h3>
      </div>
      <div class="translate-grid">
        <button @click="changeLanguage('EN'); stateTranslate = false" class="translate-item">
          <span class="lang-name">English</span>
          <span class="lang-code">EN</span>
        </button>
        <button @click="changeLanguage('ES'); stateTranslate = false" class="translate-item">
          <span class="lang-name">Español</span>
          <span class="lang-code">ES</span>
        </button>
        <button @click="changeLanguage('PT'); stateTranslate = false" class="translate-item">
          <span class="lang-name">Português</span>
          <span class="lang-code">PT</span>
        </button>
        <button @click="changeLanguage('FR'); stateTranslate = false" class="translate-item">
          <span class="lang-name">Français</span>
          <span class="lang-code">FR</span>
        </button>
      </div>
    </div>
  </header>
</template>

<script>
export default {
  name: 'headerC',
  data: function () {
    return {
      language: '',
      stateTranslate: false,
      products: false,
      showPromo: false,
      promoTimer: null,
      showTipProducts: true,
      tipProducts: {
        ES: 'Más soluciones de <strong>software innovador</strong> para tu negocio.',
        EN: 'More <strong>innovative software</strong> solutions for your business.',
        FR: 'Plus de <strong>logiciels innovants</strong> pour votre entreprise.'
      },
      productsList: [
        {
          name: 'Chatter',
          description: {
            EN: 'Real-time communication.',
            ES: 'Comunicación en tiempo real.',
            PT: 'Comunicação em tempo real.',
            FR: 'Communication en temps réel.'
          },
          link: 'https://systemico.net/products/chatter/',
          icon: 'icon-chatter.svg'
        },
        {
          name: 'Collectio',
          description: {
            EN: 'Recover payments faster with respectful reminders.',
            ES: 'Recupera pagos más rápido con recordatorios respetuosos.',
            PT: 'Recupere pagamentos mais rápido com lembretes respeitosos.',
            FR: 'Récupérez les paiements plus rápidamente avec des rappels respectueux.'
          },
          link: 'https://systemico.net/products/collectio/',
          icon: 'icon-collectio.png'
        },
        {
          name: 'Ducksites',
          description: {
            EN: 'Fast web builder.',
            ES: 'Constructor web rápido.',
            PT: 'Construtor de sites rápido.',
            FR: 'Constructeur de site rapide.'
          },
          link: 'https://systemico.net/products/ducksites/',
          icon: 'icon-ducksite.svg'
        },
        {
          name: 'FilaPro',
          description: {
            EN: 'Reduce wait times and improve service flow.',
            ES: 'Reduce filas y mejora la atención.',
            PT: 'Reduza filas e melhore o atendimento.',
            FR: 'Réduisez les files d’attente et améliorez le service.'
          },
          link: 'https://systemico.net/products/filapro/',
          icon: 'icon-filapro.png'
        },
        {
          name: 'Focusmeet',
          description: {
            EN: 'Productive meetings.',
            ES: 'Reuniones productivas.',
            PT: 'Reuniões produtivas.',
            FR: 'Réunions productives.'
          },
          link: 'https://systemico.net/products/focusmeet/',
          icon: 'icon-focusmeet.svg'
        },
        {
          name: 'Gogoals',
          description: {
            EN: 'Reach customers via SMS, email, WhatsApp, and calls.',
            ES: 'Llega a tus clientes por SMS, email, WhatsApp y llamadas.',
            PT: 'Alcance clientes por SMS, e-mail, WhatsApp e chamadas.',
            FR: 'Touchez vos clients via SMS, email, WhatsApp et appels.'
          },
          link: 'https://systemico.net/products/gogoals/',
          icon: 'icon-gogoals.svg'
        },
        {
          name: 'Grumpyturtle',
          description: {
            EN: 'Customer feedback.',
            ES: 'Feedback de clientes.',
            PT: 'Feedback do cliente.',
            FR: 'Commentaires des clients.'
          },
          link: 'https://systemico.net/products/grumpyturtle/',
          icon: 'icon-grumpyturtle.svg'
        },
        {
          name: 'PenguinStrategy',
          description: {
            EN: 'Business intelligence.',
            ES: 'Inteligencia de negocios.',
            PT: 'Inteligência de negócios.',
            FR: 'Intelligence d\'affaires.'
          },
          link: 'https://systemico.net/products/penguinstrategy/',
          icon: 'icon-penguin.svg'
        },
        {
          name: 'Provedur',
          description: {
            EN: 'Supplier management.',
            ES: 'Gestión de proveedores.',
            PT: 'Gestão de fornecedores.',
            FR: 'Gestion des fournisseurs.'
          },
          link: 'https://systemico.net/products/provedur/',
          icon: 'icon-provedur.svg'
        },
        {
          name: 'Pugobox',
          description: {
            EN: 'Logistics and tracking.',
            ES: 'Logística y seguimiento.',
            PT: 'Logística e rastreamento.',
            FR: 'Logistique et suivi.'
          },
          link: 'https://systemico.net/products/pugobox/',
          icon: 'icon-pugobox.svg'
        },
        {
          name: 'Suppmail',
          description: {
            EN: 'Smart email campaigns.',
            ES: 'Campañas de email inteligentes.',
            PT: 'Campanhas de e-mail inteligentes.',
            FR: 'Campagnes d\'e-mail intelligentes.'
          },
          link: 'https://systemico.net/suppmail/',
          icon: 'icon-suppmail.svg'
        },
        {
          name: 'Transpur',
          description: {
            EN: 'Transport solutions.',
            ES: 'Soluciones de transporte.',
            PT: 'Soluções de transporte.',
            FR: 'Solutions de transport.'
          },
          link: 'https://systemico.net/products/transpur/',
          icon: 'icon-transpur.svg'
        },
        {
          name: 'Wabot',
          description: {
            EN: 'WhatsApp automation.',
            ES: 'Automatización de WhatsApp.',
            PT: 'Automação do WhatsApp.',
            FR: 'Automatisation de WhatsApp.'
          },
          link: 'https://systemico.net/products/wabot/',
          icon: 'icon-wabot.svg'
        }
      ]
    }
  },
  props: {
    name: {
      type: String,
      required: true
    },
    logo: {
      type: String,
      required: true
    },
    lang: {
      type: String,
      required: true
    }
  },
  beforeMount () {
    this.language = this.lang
  },
  mounted () {
    /* let language = localStorage.getItem("userLanguage");
    if (language == null || language ==="ES") {
      this.language = this.lang;
    } else {
      this.language = localStorage.getItem("userLanguage");
    } */
    this.promoTimer = setTimeout(() => {
      this.showPromo = true
    }, 5000)
  },
  beforeDestroy () {
    if (this.promoTimer) {
      clearTimeout(this.promoTimer)
    }
  },
  methods: {
    showTranslate: function () {
      this.stateTranslate = !this.stateTranslate
    },
    closeTranslate: function () {
      this.stateTranslate = false
    },
    changeLanguage: function (idioma) {
      this.language = idioma
      this.$emit('changeLang', idioma)
    },
    showProducts: function () {
      this.products = !this.products
      this.showTipProducts = false
    }
  }
}
</script>

<style lang="scss">
.header {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1000;

  &__main {
    padding: 0.75rem 1.5rem;
    background-color: #171e44;
    display: flex;
    align-items: center;
    justify-content: space-between;
    box-shadow: 0 2px 10px rgba(0,0,0,0.1);
    border-bottom: 2px solid rgb(255 128 40 / var(--tw-bg-opacity, 1));
  }

  &__nav {
    margin-left: auto;
    display: flex;
    align-items: center;
  }

  &__products-dropdown, &__translate-dropdown {
    position: absolute;
    top: 100%;
    right: 1.5rem;
    width: 350px;
    background: white;
    border-radius: 0 0 12px 12px;
    box-shadow: 0 15px 35px rgba(0,0,0,0.2);
    padding: 1rem;
    z-index: 1000;
    display: flex;
    flex-direction: column;

    .dropdown-header {
      margin-bottom: 0.5rem;
      padding-bottom: 0.5rem;
      border-bottom: 1px solid #eee;

      h3 {
        font-size: 1.25rem;
        font-weight: 700;
        color: #171e44;
        margin: 0;
      }
      p {
        font-size: 0.875rem;
        color: #6c757d;
        margin: 0.25rem 0 0;
      }
    }
  }

  &__translate-dropdown {
    width: 300px;

    .translate-grid {
      display: grid;
      grid-template-columns: 1fr;
      gap: 0.5rem;
    }

    .translate-item {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 0.75rem 1rem;
      border-radius: 8px;
      transition: all 0.2s;
      text-decoration: none;
      background: transparent;
      border: 1px solid #f0f0f0;
      cursor: pointer;

      &:hover {
        background-color: #f8f9fa;
        transform: translateY(-2px);
        border-color: #ff8028;
      }

      .lang-name {
        font-weight: 600;
        color: #171e44;
        font-size: 1rem;
      }

      .lang-code {
        font-size: 0.75rem;
        font-weight: 700;
        color: #6c757d;
        background: #eee;
        padding: 2px 6px;
        border-radius: 4px;
      }
    }
  }

  &__products-dropdown {
    .products-grid {
      display: grid;
      grid-template-columns: 1fr;
      gap: 0.5rem;
      max-height: 400px;
      overflow-y: auto;
      padding-right: 5px;

      &::-webkit-scrollbar {
        width: 6px;
      }
      &::-webkit-scrollbar-track {
        background: #f1f1f1;
        border-radius: 10px;
      }
      &::-webkit-scrollbar-thumb {
        background: #ccc;
        border-radius: 10px;
      }
      &::-webkit-scrollbar-thumb:hover {
        background: #ff8028;
      }
    }

    .product-item {
      display: flex;
      align-items: center;
      padding: 0.4rem 0.6rem;
      border-radius: 8px;
      transition: all 0.3s ease;
      text-decoration: none;
      margin-bottom: 0.1rem;
      border: 1px solid transparent;

      &:hover {
        background-color: #ffffff;
        transform: translateX(4px);
        box-shadow: 0 4px 12px rgba(0,0,0,0.08);
        border-color: #ff8028;

        .product-name {
          color: #ff8028;
        }

        .product-icon {
          background-color: #fff4ed;
        }
      }

      .product-icon {
        width: 40px;
        height: 40px;
        margin-right: 1rem;
        display: flex;
        align-items: center;
        justify-content: center;
        background-color: #f8f9fa;
        border-radius: 8px;
        transition: all 0.3s ease;

        img {
          max-width: 24px;
          max-height: 24px;
          transition: transform 0.3s ease;
        }
      }

      &:hover .product-icon img {
        transform: scale(1.1) rotate(5deg);
      }

      .product-info {
        display: flex;
        flex-direction: column;

        .product-name {
          font-weight: 600;
          color: #171e44;
          font-size: 0.95rem;
          line-height: 1.2;
        }
        .product-description {
          font-size: 0.75rem;
          color: #6c757d;
          line-height: 1.2;
        }
      }
    }

    .dropdown-footer {
      margin-top: 0.5rem;
      padding-top: 0.5rem;
      border-top: 1px solid #eee;
      text-align: right;

      a {
        font-size: 0.875rem;
        font-weight: 600;
        color: #006df0;
        text-decoration: none;

        &:hover {
          text-decoration: underline;
        }
      }
    }
  }

  @media (max-width: 768px) {
    &__products-dropdown, &__translate-dropdown {
      left: 0;
      width: 100%;
      position: fixed;
      top: 60px;
      height: calc(100vh - 60px);
      overflow-y: auto;
      border-radius: 0;
    }

    &__products-dropdown {
      .products-grid {
        grid-template-columns: 1fr;
        gap: 0.5rem;
        max-height: none;
      }
    }
  }

  // responsive para dispositivos de tablets en adelante
  @media (min-width: 992px) {
    justify-content: inherit;

    &__menu {
      display: none;
    }
  }
}

.products-link {
  margin-right: 20px;

  .btn-products {
    background: transparent;
    border: 0;
    color: white;
    font-family: "Quicksand", sans-serif;
    font-size: 14px;
    font-weight: 600;
    padding: 5px 10px;
    transition: all 0.2s;

    &:hover {
      color: #ff8028;
    }
  }
}

.translate {
  margin-right: 20px;
  position: relative;

  // &.show {
  //   .btn-translate {
  //     svg {
  //       color: #ff8028;
  //     }
  //   }
  // }

  // &.show {
  //   .options-translate {
  //     height: auto;
  //   }
  // }
}

.btn-translate {
  width: 30px;
  min-width: 30px;
  height: 30px;
  margin: 0 auto;
  border: 0;
  background: transparent;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  cursor: pointer;

  svg {
    font-size: 20px;
    color: white;
    pointer-events: none;
  }

  span {
    padding: 0 4px;
    border-radius: 30px;
    background-color: white;
    font-family: "Mulish", sans-serif;
    font-size: 10px;
    font-weight: bold;
    color: #171e44;
    text-align: center;
    text-transform: uppercase;
    position: absolute;
    top: 15px;
    left: 15px;
  }

  &:hover {
    svg {
      color: #ff8028;
    }
  }
}

.slide-fade-enter-active {
  transition: all 0.5s ease;
}
.slide-fade-leave-active {
  transition: all 0.3s cubic-bezier(1.0, 0.5, 0.8, 1.0);
}
.slide-fade-enter, .slide-fade-leave-to {
  transform: translateX(20px);
  opacity: 0;
}

.header__floating-promo {
  position: fixed;
  bottom: 60px;
  right: 20px;
  width: 300px;
  background: white;
  border-radius: 16px;
  box-shadow: 0 15px 35px rgba(255, 128, 40, 0.2), 0 5px 15px rgba(0,0,0,0.1);
  padding: 1.25rem;
  z-index: 999;
  border: 1px solid rgba(255, 128, 40, 0.1);
  border-left: 5px solid #ff8028;
  display: flex;
  flex-direction: column;
  animation: promo-pulse 3s infinite ease-in-out;

  @keyframes promo-pulse {
    0% {
      transform: translateY(0) scale(1);
      box-shadow: 0 15px 35px rgba(255, 128, 40, 0.2), 0 5px 15px rgba(0,0,0,0.1);
      border-color: rgba(255, 128, 40, 0.1);
    }
    50% {
      transform: translateY(-5px) scale(1.02);
      box-shadow: 0 25px 50px rgba(255, 128, 40, 0.35), 0 10px 20px rgba(0,0,0,0.15);
      border-color: rgba(255, 128, 40, 0.5);
    }
    100% {
      transform: translateY(0) scale(1);
      box-shadow: 0 15px 35px rgba(255, 128, 40, 0.2), 0 5px 15px rgba(0,0,0,0.1);
      border-color: rgba(255, 128, 40, 0.1);
    }
  }

  .close-promo {
    position: absolute;
    top: 8px;
    right: 8px;
    background: transparent;
    border: 0;
    color: #94a3b8;
    cursor: pointer;
    padding: 2px;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: color 0.2s;

    &:hover {
      color: #ef4444;
    }

    svg {
      font-size: 1.2rem;
    }
  }

  .promo-content {
    .promo-header {
      display: flex;
      align-items: flex-start;
      gap: 12px;
      margin-bottom: 0.75rem;

      .promo-icon {
        flex-shrink: 0;
        width: 40px;
        height: 40px;
        background-color: rgba(255, 128, 40, 0.1);
        border-radius: 10px;
        display: flex;
        align-items: center;
        justify-content: center;
        color: #ff8028;

        svg {
          width: 24px;
          height: 24px;
        }
      }
    }

    p {
      font-size: 0.9rem;
      font-weight: 600;
      color: #171e44;
      margin-bottom: 0;
      line-height: 1.4;
      padding-right: 15px;
    }

    .promo-actions {
      display: flex;
      flex-direction: column;
      gap: 8px;
    }

    .promo-button {
      display: inline-flex;
      align-items: center;
      justify-content: center;
      background-color: #ff8028;
      color: white;
      padding: 0.6rem 1rem;
      border-radius: 10px;
      font-size: 0.85rem;
      font-weight: 700;
      text-decoration: none !important;
      transition: all 0.3s ease;
      text-align: center;
      width: 100%;

      &.discount {
        background-color: #10b981;

        &:hover {
          background-color: #059669;
          box-shadow: 0 4px 12px rgba(16, 185, 129, 0.3);
        }
      }

      &.secondary {
        background-color: #171e44;

        &:hover {
          background-color: #0d122a;
          box-shadow: 0 4px 12px rgba(23, 30, 68, 0.3);
        }
      }

      &:hover {
        background-color: #e67324;
        transform: translateY(-2px);
        box-shadow: 0 4px 12px rgba(255, 128, 40, 0.3);
        color: white;
      }

      svg {
        margin-left: 6px;
        font-size: 1.1rem;
      }
    }
  }
}

@media (max-width: 768px) {
  .header__floating-promo {
    width: calc(100% - 40px);
    bottom: 80px;
    right: 20px;
    left: 20px;
  }
}
</style>
